import { render } from "./MenuMobButton.vue?vue&type=template&id=7a97644b&scoped=true"
import script from "./MenuMobButton.vue?vue&type=script&lang=js"
export * from "./MenuMobButton.vue?vue&type=script&lang=js"

import "./MenuMobButton.vue?vue&type=style&index=0&id=7a97644b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a97644b"]])

export default __exports__